import React from 'react';
import { Grid, Typography } from '@mui/material';

interface Props {
  day: string;
}

export function AppDayName({ day }: Props): JSX.Element {
  if (day == '') {
    return <Grid item xs={0.8}></Grid>;
  }

  if (day == 'Sa' || day == 'Su') {
    return (
      <Grid item xs={1.6}>
        <Typography variant="h2" fontSize={18} sx={{ lineHeight: 1.235 }}>
          {day}
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid item xs={1.6}>
      <Typography variant="h4" fontSize={18}>
        {day}
      </Typography>
    </Grid>
  );
}
